export class Botao {
  texto: string;
  icone?: string;
  cor?: 'primary' | 'accent' | 'warn' | '';
  tooltip?: string;
  aoClicar?: () => void;
  show?: (element: any) => boolean;
  disabled?: (element: any) => boolean;
};
export class BotaoMenu extends Botao {
  opcoesMenu?: Array<{ name: string, method: (selection: any[]) => void, show?: (element: any) => boolean, disabled?: (element: any) => boolean }>;
}